export default __webpack_public_path__ + "static/media/favoritesGray.f6ef2713.svg";